module.exports = __webpack_public_path__ + "static/media/icon-up.95f916a5.svg";